import { useContext, useState, useEffect, useCallback } from "react";
import { TOContext } from "context/TContext";
import { formatNumber, priceTransform } from "helpers/formatNumber";


const useCashConfig = (handleCashSubmit) => {
	const {
		CASH,
		payWithCreditCard,
		isRefundDueShow,
		charges,
		setCharges,
		selectedDriverTip,
		cashPaid,
		setCashPaid,
		setSelectedDriverTip,
		actionInProgress,
	} = useContext(TOContext);

	const [cashError, setCashError] = useState('');
	const [tipAmountValue, setTipAmountValue] = useState(0);
	const [isInputFocused, setIsInputFocused] = useState(false);

	// Prefill the cash amount with the balance due when the payment method is selected
	useEffect(() => {
		if (payWithCreditCard === CASH && charges?.balanceDue) {
			setTipAmountValue(charges?.tipInfo?.driver || 0);
		} else if (payWithCreditCard !== CASH && cashError) {
			setCashError('');
		}
	}, [
		payWithCreditCard,
		CASH,
		charges?.tipInfo?.driver,
		charges?.balanceDue
	]);


	useEffect(() => {
		if (selectedDriverTip) {
			setCashPaid(charges?.balanceDue?.toFixed(2) || 0);
		}
	}, [selectedDriverTip, charges?.balanceDue]);

	useEffect(() => {
		if (payWithCreditCard !== CASH) {
			setCashError('');
		}
	}, [payWithCreditCard]);

	const handleCashPaidChange = (event) => {
		const value = priceTransform(event.target.value);
		if (value === '' || /^\d+(\.\d{0,2})?$/.test(value)) {
			setCashPaid(formatNumber(value));
			const tip = parseFloat(charges?.tipInfo?.driver || 0);
			const balanceDue = parseFloat(charges.balanceDue);
			const adjustedBalance = parseFloat((balanceDue - tip).toFixed(2));

			if (Number(value) < Number(adjustedBalance)) {
				setCashError('Cash amount must be at least the balance due');
				return;
			}

			if (value) {
				const tipAmount = parseFloat(
					(parseFloat(value) - 
					parseFloat(charges.balanceDue) +
				  (charges?.tipInfo?.driver || 0)).toFixed(2)
				);
				const tipAmountValue = tipAmount > 0 ? tipAmount?.toFixed(2) : 0;
				setTipAmountValue(tipAmountValue);
				setCashError('');
			}
		}
	};

	const updateChargesSafely = useCallback((tipAmount) => {
		setCharges(prevCharges => ({
			...prevCharges,
			tipInfo: {
				...prevCharges?.tipInfo,
				driver: Number(tipAmount) || 0
			},
			balanceDue: (prevCharges?.balanceDue) - (prevCharges?.tipInfo?.driver || 0) + (Number(tipAmount) || 0),
			total: (prevCharges?.total) - (prevCharges?.tipInfo?.driver || 0) + (Number(tipAmount) || 0),
		}));

	}, [setCharges]);

	const handleBlur = () => {
		setIsInputFocused(false);
		if (tipAmountValue || tipAmountValue === 0) {
			const driverTip = parseFloat(charges?.tipInfo?.driver || 0);
			const balanceDueAmount = parseFloat(charges.balanceDue);
			const balanceWithoutTip = (balanceDueAmount - driverTip).toFixed(2);
			const values = parseFloat(balanceWithoutTip).toFixed(2);
			if (Number(cashPaid) < Number(values)) {
				setCashError('Cash amount must be at least the balance due');
				return;
			}
			setSelectedDriverTip(null);
			setTipAmountValue(tipAmountValue);
			updateChargesSafely(tipAmountValue);
			setCashError('');
		}
	}


	const handleCashPayment = () => {
		if (!cashError && cashPaid) {
			const cashAmount = parseFloat(cashPaid);
			handleCashSubmit({
				cashAmount,
				tipAmount: tipAmountValue > 0 ? tipAmountValue : 0,
				cashPaid: cashPaid
			});
		}
	};

	return {
		handleCashPaidChange,
		handleCashPayment,
		tipAmountValue,
		cashError,
		isRefundDueShow,
		cashPaid,
		isRefundDueShow,
		CASH,
		payWithCreditCard,
		balanceDue: charges?.balanceDue,
		actionInProgress,
		handleBlur,
		setIsInputFocused,
		isInputFocused,
	}
}

export default useCashConfig;